import Net from '../../util/net';
import {
  AddStickerReq,
  AddStickerRsp,
  GetCollectStickerListReq,
  GetCollectStickerListRsp,
  ImageInfo,
  StickerItem,
  UserAtInfoApartReq,
  UserAtInfoApartRsp,
  GetImReactionListBatchReq,
  ImReactionOptReq,
  GetImReactionListBatchRsp,
  ReactionList,
  ReportReadInfoRsp,
  ReportReadInfoReq,
  StickerMsg,
  RecallGroupMsgRsp,
  RecallGroupMsgReq,
  SendOperEventRsp,
  SendOperEventReq,
  CheckMsgExistReq,
  CheckMsgExistRsp,
  ChannelForwardInfo,
  C2CForwardInfo,
  ForwardMsgItem,
  UploadForwardMsgItem,
  UploadForwardMsgRsp,
  UploadForwardMsgReq,
  UploadForwardMsgForShareRsp,
  UploadForwardMsgForShareReq,
  ShareScene,
  GetForwardMsgInfoOuterReq,
  GetForwardMsgInfoOuterRsp, ImReactionOptRsp, RecallType, MsgScope,
} from '../../typings/proto';

export type TUnReadCount = {
  [key: string]: number
};

export type TUnReadAtCount = {
  atAll: TUnReadCount,
  atMe: TUnReadCount
};

export default {
  getUnreadAtCount(channelIds: Array<string>): Promise<TUnReadAtCount> {
    return new Promise((resolve, reject) => {
      Net.request<UserAtInfoApartRsp, UserAtInfoApartReq>({
        data: {
          channelIds,
        },
        serverName: 'ImSrv',
        funcName: 'UserAtInfoApart',
      })
        .then((data) => {
          const result: {
            atMe: Record<string, number>,
            atAll: Record<string, number>
          } = {
            atMe: {},
            atAll: {},
          };
          if (data.channelToAtAllNum) {
            Object.keys(data.channelToAtAllNum).forEach((key) => {
              result.atAll[key] = parseInt(data.channelToAtAllNum[key], 10);
            });
          }

          if (data.channelToAtMeNum) {
            Object.keys(data.channelToAtMeNum).forEach((key) => {
              result.atMe[key] = parseInt(data.channelToAtMeNum[key], 10);
            });
          }

          if (data.channelToAtRoleGroupNum) {
            Object.keys(data.channelToAtMeNum).forEach((key) => {
              result.atMe[key] = parseInt(data.channelToAtMeNum[key], 10);
            });
          }
          resolve(result);
        })
        .catch(reject);
    });
  },
  userAtInfoApart(channelIds: Array<string>): Promise<UserAtInfoApartRsp> {
    return Net.request<UserAtInfoApartRsp, UserAtInfoApartReq>({
      data: {
        channelIds,
      },
      serverName: 'ImSrv',
      funcName: 'UserAtInfoApart',
    });
  },
  /** 获取表情包列表 */
  getCollectStickerList(): Promise<StickerItem[]> {
    return new Promise((resolve, reject) => {
      Net.request<GetCollectStickerListRsp, GetCollectStickerListReq>({
        serverName: 'ImStickerSrv',
        funcName: 'GetCollectStickerList',
      })
        .then((data) => {
          resolve(data.list);
        })
        .catch(reject);
    });
  },
  /** 添加表情包 */
  addSticker(
    url: string,
    md5: string,
    w: number,
    h: number,
    origUrl: string,
  ): Promise<AddStickerRsp> {
    return new Promise((resolve, reject) => {
      Net.request<AddStickerRsp, AddStickerReq>({
        serverName: 'ImStickerSrv',
        funcName: 'AddSticker',
        data: {
          url,
          md5,
          w,
          h,
          origUrl,
        },
      })
        .then((data) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  /** 将图片信息添加为表情包 */
  addPicMsgSticker(imageInfo: ImageInfo): Promise<AddStickerRsp> {
    return this.addSticker(
      imageInfo.url,
      imageInfo.md5sum,
      imageInfo.width,
      imageInfo.height,
      imageInfo.url,
    );
  },
  /** 将表情信息添加为表情包 */
  addStickerMsgSticker(stickerMsg: StickerMsg): Promise<AddStickerRsp> {
    return this.addSticker(
      stickerMsg.url,
      stickerMsg.md5sum,
      stickerMsg.width,
      stickerMsg.height,
      stickerMsg.origUrl,
    );
  },
  getImReactionListBatch(
    cid: string,
    msgSeqList: string[],
  ): Promise<Record<string, ReactionList>> {
    return Net.request<GetImReactionListBatchRsp, GetImReactionListBatchReq>({
      serverName: 'ImReactionSrv',
      funcName: 'GetImReactionListBatch',
      data: {
        channelId: cid,
        msgSeq: msgSeqList,
      },
    }).then(data => data.reations);
  },
  imReactionOpt(params: ImReactionOptReq): Promise<ImReactionOptRsp> {
    return Net.request<ImReactionOptRsp, ImReactionOptReq>({
      serverName: 'ImReactionSrv',
      funcName: 'ImReactionOpt',
      data: params,
    });
  },

  /**
   * 上报消息已读
   * @param channelId
   * @param msgSeq
   */
  reportReadInfo(
    channelId: string,
    msgSeq: string,
  ): Promise<ReportReadInfoRsp> {
    return Net.request<ReportReadInfoRsp, ReportReadInfoReq>({
      serverName: 'ImSrv',
      funcName: 'ReportReadInfo',
      data: {
        msgSeq: String(msgSeq),
        channelId,
      },
    });
  },

  /**
   * 消息撤回
   * @param channelId
   * @param msgSeq
   * @param messageId
   */
  revokeMessage(
    channelId: string,
    msgSeq: string,
    messageId: string,
  ): Promise<RecallGroupMsgRsp> {
    return Net.request<RecallGroupMsgRsp, RecallGroupMsgReq>({
      serverName: 'ImRecallSrv',
      funcName: 'RecallGroupMsg',
      data: {
        channelId,
        msgSeq,
        messageId,
        msgSeqList: [],
        recallType: RecallType.NormalRecall,
      },
    });
  },
  /**
   * webhook消息
   * @param botId
   * @param params
   * @param target
   */

  postWebhookMessage(
    botId: string,
    target: string,
    params: string,
  ): Promise<SendOperEventRsp> {
    return Net.request<SendOperEventRsp, SendOperEventReq>({
      serverName: 'BotDeveloperSrv',
      funcName: 'SendOperEvent',
      data: {
        botId,
        target,
        params,
      },
    });
  },
  /**
   * 检查转发消息
   */
  checkForwardMsg(
    scope: MsgScope,
    channelForwardInfo: ChannelForwardInfo,
    c2cForwardInfo: C2CForwardInfo,
    itemList: Array<ForwardMsgItem>,
  ): Promise<CheckMsgExistRsp> {
    return Net.request<CheckMsgExistRsp, CheckMsgExistReq>({
      serverName: 'ImForwardSrv',
      funcName: 'CheckMsgExist',
      data: {
        scope,
        channelForwardInfo,
        c2cForwardInfo,
        itemList,
      },
    });
  },

  /**
   * 上传转发消息
   */
  uploadForwardMsg(
    scope: MsgScope,
    channelForwardInfo: ChannelForwardInfo,
    c2cForwardInfo: C2CForwardInfo,
    itemList: Array<UploadForwardMsgItem>,
  ): Promise<UploadForwardMsgRsp> {
    return Net.request<UploadForwardMsgRsp, UploadForwardMsgReq>({
      serverName: 'ImForwardSrv',
      funcName: 'UploadForwardMsg',
      data: {
        scope,
        channelForwardInfo,
        c2cForwardInfo,
        itemList,
      },
    });
  },

  /**
   * 转发消息换取唯一id
   */
  uploadForwardMsgForShare(
    scope: MsgScope,
    channelForwardInfo: ChannelForwardInfo,
    c2cForwardInfo: C2CForwardInfo,
    itemList: Array<ForwardMsgItem>,
    shareScene: ShareScene,
  ): Promise<UploadForwardMsgForShareRsp> {
    return Net.request<UploadForwardMsgForShareRsp, UploadForwardMsgForShareReq>({
      serverName: 'ImForwardSrv',
      funcName: 'UploadForwardMsgForShare',
      data: {
        scope,
        channelForwardInfo,
        c2cForwardInfo,
        itemList,
        shareScene,
        items: [],
      },
    });
  },

  getForwardMsgInfo(uploadId: string): Promise<GetForwardMsgInfoOuterRsp> {
    return Net.request<GetForwardMsgInfoOuterRsp, GetForwardMsgInfoOuterReq>({
      serverName: 'ImForwardSrv',
      funcName: 'GetForwardMsgInfoOuter',
      data: {
        uploadId,
        needExtendInfo: 1,
      },
    });
  },
};
